/* assets/src/utils/HashRouter.js
 *
 * Very small hash-based router.
 *  - Keeps state in the URL fragment after "#!"
 *  - Triggers `onChange(stateObj)` whenever hash changes
 */
export class HashRouter {
  constructor(onChange = () => {}) {
    // this.onChange = onChange;
    // window.addEventListener('hashchange', () => this.onChange(this.get()));

    this.onChange = onChange;

    // Track the last state for back-button logic
    this._last = this.get();

    // Only user-driven back/forward triggers this; your programmatic nav calls onChange directly
    window.addEventListener('hashchange', () => {
      const prev = this._last;
      const next = this.get();

      if (prev?.step === 'confirm' && next.step !== 'confirm') {
        // Do NOT call history.forward(); let syncWithState handle closing
        this._last = next;
        this.onChange(next);
        return;
      }

      this._last = next;
      this.onChange(next);
    });
    // window.addEventListener('hashchange', () => {
    //   const next = this.get();

    //   // Intercept back from #!step=confirm
    //   if (this._last.step === 'confirm' && next.step !== 'confirm') {
    //     // Stay on confirmation
    //     history.forward(); // prevent back
    //     return;
    //   }

    //   this._last = next;
    //   this.onChange(next);
    // });
  }

  /* Parse #!a=1&b=2 → {a:"1", b:"2"} */
  get() {
    const raw = location.hash.startsWith('#!') ? location.hash.slice(2) : '';
    return Object.fromEntries(new URLSearchParams(raw));
  }

  /* Merge & push a new state (adds a browser-history entry) */
  push(params = {}) {
    const next = { ...this.get(), ...params };
    const qs   = new URLSearchParams(next).toString();
    history.pushState(null, '', '#!' + qs);
    this._last = next;
    this.onChange(next);
  }

  /* Merge & replace the current hash (without adding browser history entry) */
  replace(params = {}, { silent = false } = {}) {
    const next   = { ...this.get(), ...params };
    const qs     = new URLSearchParams(next).toString();
    const newHash = '#!' + qs;

    if (location.hash !== newHash) {
      history.replaceState(null, '', newHash);
    }

    this._last = next;
    if (!silent) this.onChange(next);  // ← Do not call during modal close
  }

  // replace(params = {}) {
  //   const next = { ...this.get(), ...params };
  //   const qs   = new URLSearchParams(next).toString();
  //   history.replaceState(null, '', '#!' + qs);
  //   this._last = next;
  //   this.onChange(next);
  // }
  
  /* Helper that only *returns* a hash string, doesn’t touch history */
  href(params = {}) {
    const next = { ...this.get(), ...params };
    return '#!' + new URLSearchParams(next).toString();
  }

}
